import EmailCreationTeamAssignSelect from './EmailCreationTeamAssignSelect';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIButton from 'UIComponents/button/UIButton';
import { H2 } from 'UIComponents/elements/headings';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import { EMAIL_TYPE_PANEL_WIDTH } from 'EmailData/constants/emailCreation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function EmailCreationTeamAssignPanel({
  fetchedTeams,
  selectedTeamIds,
  setSelectedTeamIds,
  setShowTeamAssignPanel,
  setShowEmailTemplateModeModal
}) {
  const handleOnClick = () => {
    setShowTeamAssignPanel(false);
    setShowEmailTemplateModeModal(true);
  };
  return /*#__PURE__*/_jsxs(UIModalPanel, {
    "data-test-id": "email-creation-team-assign-panel",
    width: EMAIL_TYPE_PANEL_WIDTH,
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "EmailComponents.emailCreation.buttonText"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: () => setShowTeamAssignPanel(false)
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(EmailCreationTeamAssignSelect, {
        fetchedTeams: fetchedTeams,
        selectedTeamIds: selectedTeamIds,
        setSelectedTeamIds: setSelectedTeamIds
      })
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "cream-email-button-in-team-assign-panel",
        disabled: selectedTeamIds.length < 1,
        onClick: handleOnClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "EmailComponents.emailCreation.buttonText"
        })
      })
    })]
  });
}
export default EmailCreationTeamAssignPanel;